export default "__VITE_ASSET__ed96b1fb__"